import {
  AddEditBudget,
  AddEditCommunity,
  AddEditConfig,
  AddEditLineItem,
  AddEditOwner,
  AddEditProperty,
  AddEditVendor,
  BudgetMgmt,
  BudgetViewJobDetails,
  BudgetViewJobGlDetails,
  Communities,
  CommunityDetails,
  DocumentTypeConfig,
  LineItems,
  Properties,
  Users,
  UsersList,
  VendorMgmt,
} from "@/pages";
import { routes } from "../utils";

export const CommunityRoutes = () => {
  return {
    path: routes.communities,
    children: [
      {
        path: "",
        element: <Communities />,
      },
      {
        path: routes.action,
        element: <AddEditCommunity />,
      },
      {
        path: routes.id + "/" + routes.action,
        element: <AddEditCommunity />,
      },
      {
        path: routes.id + "/" + routes.details,
        element: <CommunityDetails />,
      },
      {
        path: routes.id + "/" + routes.properties,
        element: <Properties />,
      },
      {
        path: routes.id + "/" + routes.users,
        element: <UsersList />,
      },
      {
        path: routes.id + "/" + routes.budgetMgmt,
        element: <BudgetMgmt />,
      },
      {
        path: routes.id + "/" + routes.budgetMgmt + "/" + routes.add,
        element: <AddEditBudget />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.simulate,
        element: <BudgetViewJobDetails />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.simulate + "/" + routes.glId,
        element: <BudgetViewJobGlDetails />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.action,
        element: <AddEditBudget />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.lineItems,
        element: <LineItems />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.lineItems +
          "/" +
          routes.add,
        element: <AddEditLineItem />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.lineItems +
          "/" +
          routes.lineItemId +
          "/" +
          routes.action,
        element: <AddEditLineItem />,
      },
      {
        path: routes.id + "/" + routes.properties + "/" + routes.add,
        element: <AddEditProperty />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.properties +
          "/" +
          routes.propertyId +
          "/" +
          routes.action,
        element: <AddEditProperty />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.properties +
          "/" +
          routes.propertyId +
          "/" +
          routes.users,
        element: <Users />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.properties +
          "/" +
          routes.propertyId +
          "/" +
          routes.users +
          "/" +
          routes.add,
        element: <AddEditOwner />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.properties +
          "/" +
          routes.propertyId +
          "/" +
          routes.users +
          "/" +
          routes.userId +
          "/" +
          routes.action,
        element: <AddEditOwner />,
      },
      {
        path: routes.id + "/" + routes.documentTypeConfig,
        element: <DocumentTypeConfig />
      },
      {
        path: routes.id + "/" + routes.documentTypeConfig + "/" + routes.add,
        element: <AddEditConfig />
      },
      {
        path:
          routes.id +
          "/" +
          routes.documentTypeConfig +
          "/" +
          routes.documentTypeId +
          "/" +
          routes.action,
        element: <AddEditConfig />
      },
      {
        path: routes.id + "/" + routes.vendorMgmt,
        element: <VendorMgmt />,
      },
      {
        path: routes.id + "/" + routes.vendorMgmt + "/" + routes.add,
        element: <AddEditVendor />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.vendorMgmt +
          "/" +
          routes.vendorId +
          "/" +
          routes.action,
        element: <AddEditVendor />,
      },
    ],
  };
};
